export const AlertMixin = (klass) => class extends klass {
  clearError(callback){
    this.setState({
      alert: {
        display: false
      }
    }, callback)
  }

  displayError(e, callback) {
    let msg =this.getTranslation('ERROR_GENERIC');
    if (e != null && e.hasOwnProperty("translatedMessage")){
      if (e.translatedMessage) {
        msg = e.translatedMessage;
      }
    }
    this.setState({
      alert: {
        display: true,
        type: 'error',
        message: msg,
      },
    }, callback);
  }

  displayAlert(msg, type, callback) {
    this.setState({
      alert: {
        display: true,
        type: type,
        message: msg,
      },
    }, callback);
  }
}